<template>
    <div class="page-content margin-bottom-60">
        <div class="center-text own-title margin-bottom-30">
            Success Roadmap
        </div>
        <div class="content card round-medium" :style="loadBg">
            <div class="top-bar" :style="loadBar"></div>
            <div class="content-title padding-5 margin-top-10">
                <div class="roadmap-back-wrapper ipad-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0">
                        <img :src="'images/mpower/back.png'" class="responsive-image roadmap-back-img"/> <span class="">Back to Success Road Map</span>
                    </router-link>
                </div>
                <div class="roadmap-back-wrapper mobile-display">
                    <router-link :to="'success-roadmap'" class="margin-top-0 ">
                        <img :src="'images/mpower/back.png'" class="responsive-image roadmap-back-img"/>
                    </router-link>
                </div>
                <div class="roadmap-title-wrapper">
                    Agents Development<br> Journey (BOSS)
                </div>
                <div class="clear"></div>
            </div>
            <!-- mobile -->
            <div class="mobile-display">
                <div>
                    <img :src="'images/mpower/roadmap/2022/Boss_Agents-Development-Journey_Y1.png'" class="responsive-image" />
                </div>
                <!-- <div>
                    <img :src="'images/mpower/roadmap/2022/Boss_Agents-Development-Journey_Y2.png'" class="responsive-image" />
                </div> -->
                <div class="margin-bottom-10">
                    <img :src="'images/mpower/roadmap/2022/Boss_Agents-Development-Journey_Y2.png'" class="responsive-image" />
                    <!-- <img :src="'images/mpower/roadmap/eye-agent-set3.gif'" class="responsive-image" /> -->
                </div>
                <p class="mandatory">*Compulsory Training Requirement</p>
            </div>

            <!-- ipad -->
            <div class="ipad-display">
              <div class="center-image">
                <div class="col-1">
                    <img :src="'images/mpower/roadmap/2022/Boss_Agents-Development-Journey_Y1.png'" class="responsive-image" />
                </div>
                <div class="col-1">
                    <img :src="'images/mpower/roadmap/2022/Boss_Agents-Development-Journey_Y2.png'" class="responsive-image" />
                </div>
                <!-- <div class="col-1">
                    <img :src="'images/mpower/roadmap/2022/Boss_Agents-Development-Journey_Y1.png'" class="responsive-image" />
                </div> -->
              </div>
                <div class="clear"></div>
                <p class="mandatory">*Compulsory Training Requirement</p>
            </div>
        </div>
        <RoadmapNav />
    </div>
</template>
<style scoped>
.mobile-display .mandatory{
    text-align: left;
    font-style: italic;
    padding-left: 10px;
    color:#6b867f;
}
.ipad-display .mandatory{
    text-align: left;
    font-style: italic;
    padding-left: 160px;
    color:#6b867f;
}
.center-image{
  display: flex !important;
  justify-content: center;
}
</style>
<script>
import RoadmapNav from '@/components/RoadmapNav.vue'
export default {
    name: 'Agent_journey_boss',
    computed: {
        loadBg(){
            return {
                'backgroundImage': 'url(\'images/mpower/roadmap/blank_bg.png\')',
                'background-size': 'cover',
                'background-position': 'center',
                'background-repeat': 'no-repeat'
            }
        },
        loadBar() {
            return {
                'background': '#FFB6C1'
            }
        }
    },
    components: {
        RoadmapNav
    },
    mounted(){
        window.scrollTo(0,0);
    }
}
</script>
